__turbopack_context__.v({
  "app_light_theme": "RadioButton-module-scss-module__D4tTqG__app_light_theme",
  "radioButton": "RadioButton-module-scss-module__D4tTqG__radioButton",
  "radioButton__checked": "RadioButton-module-scss-module__D4tTqG__radioButton__checked",
  "radioButton__content": "RadioButton-module-scss-module__D4tTqG__radioButton__content",
  "radioButton__disabled": "RadioButton-module-scss-module__D4tTqG__radioButton__disabled",
  "radioButton__input": "RadioButton-module-scss-module__D4tTqG__radioButton__input",
  "radioButton__solid": "RadioButton-module-scss-module__D4tTqG__radioButton__solid",
});
